import styled from 'styled-components';
import { Typography } from '@mesa-labs/mesa-ui';

const OnboardingHeader = styled(Typography.H1)`
  color: #0E121B;
  font-family: ${(props) => props.theme.fonts.grotesk};
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin: 0px 0px 4px 0px;
  text-align: left;

  @media (min-width: ${(props) => props.theme.breakpoints.Tablet}) {
    margin: 0px 0px 8px 0px;
  }
`;

export default OnboardingHeader;
